<template>
  <span>
    <v-btn
      v-if="podePlanejar"
      height="39"
      :disabled="disabled"
      class="
        ma-1
        font-weight-bold
        text-none
        btn-primary
        bg-gradient-primary
        px-6
        ms-3
      "
      @click="abrir"
    >
      <v-icon left>mdi-routes</v-icon>{{ $t("roteirizacaoPedidos.botao") }}
    </v-btn>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="100%"
      :transition="false"
      content-class="crud-base-form-dialog roteirizacao-dialog"
    >
      <v-container fluid class="crud-form-page roteirizacao">
        <v-card
          class="
            card-shadow
            border-radius-xl
            crud-form-card
            roteirizacao__cartao
          "
        >
          <div
            class="card-header-padding crud-form-topbar roteirizacao__topbar"
          >
            <div class="d-flex justify-end crud-form-topbar__actions">
              <v-btn
                v-if="plano"
                outlined
                height="39"
                class="text-none font-weight-bold"
                :disabled="requesting"
                @click="atualizarPlano"
              >
                <v-icon left>mdi-refresh</v-icon>
                {{ $t("roteirizacaoPedidos.atualizar") }}
              </v-btn>
              <v-btn
                v-if="plano"
                outlined
                height="39"
                class="text-none font-weight-bold"
                :disabled="ocupado"
                @click="novoPlanejamento"
              >
                <v-icon left>mdi-plus</v-icon>
                {{ $t("roteirizacaoPedidos.novo") }}
              </v-btn>
              <v-btn
                outlined
                height="39"
                class="text-none font-weight-bold"
                :disabled="requesting"
                @click="fechar"
              >
                <v-icon left>mdi-close</v-icon>
                {{ $t("Fechar") }}
              </v-btn>
            </div>
          </div>

          <div
            class="
              card-header-padding card-border-bottom
              crud-form-heading crud-form-heading--between
              roteirizacao__cabecalho
            "
          >
            <div class="crud-form-heading__main">
              <div class="crud-form-heading__icon" aria-hidden="true">
                <v-icon color="#5e72e4" size="21">mdi-routes</v-icon>
              </div>
              <div class="crud-form-heading__content">
                <span class="crud-form-heading__kicker">
                  {{ $t("roteirizacaoPedidos.kicker") }}
                </span>
                <span
                  class="
                    font-weight-600
                    text-h3 text-typo
                    mb-0
                    crud-form-heading__title
                  "
                >
                  {{ $t("roteirizacaoPedidos.titulo") }}
                </span>
                <span class="roteirizacao__subtitulo">
                  <v-icon x-small color="#667085" class="mr-1">
                    mdi-calendar-blank-outline
                  </v-icon>
                  {{ dataFormatada }}
                  <span v-if="plano" class="roteirizacao__estado">
                    {{ rotuloEstado(plano.estado) }}
                  </span>
                </span>
              </div>
            </div>
            <ol class="roteirizacao-etapas">
              <li
                v-for="(etapa, indice) in etapas"
                :key="etapa"
                class="roteirizacao-etapas__item"
                :class="{
                  'roteirizacao-etapas__item--ativa': indice === etapaAtual,
                  'roteirizacao-etapas__item--concluida': indice < etapaAtual,
                }"
                :aria-current="indice === etapaAtual ? 'step' : null"
              >
                <span class="roteirizacao-etapas__numero">
                  <v-icon v-if="indice < etapaAtual" x-small color="#fff">
                    mdi-check
                  </v-icon>
                  <template v-else>{{ indice + 1 }}</template>
                </span>
                {{ etapa }}
              </li>
            </ol>
          </div>

          <div class="loading-container roteirizacao__corpo">
            <div
              v-if="carregando"
              class="loading-overlay roteirizacao__carregando"
              role="status"
            >
              <div class="loading-card">
                <span class="spinner"></span>
                <span class="label">
                  {{ textoCarregamento }}
                  <small
                    v-if="processandoNoMotor"
                    class="roteirizacao__carregando-ajuda"
                  >
                    {{ $t("roteirizacaoPedidos.podeFechar") }}
                  </small>
                </span>
              </div>
            </div>

            <div
              v-if="erro"
              class="roteirizacao-aviso roteirizacao-aviso--erro"
              role="alert"
            >
              <v-icon small color="#b42318">mdi-alert-circle-outline</v-icon>
              <div>{{ erro }}</div>
            </div>
            <div
              v-if="plano && plano.erro"
              class="roteirizacao-aviso roteirizacao-aviso--alerta"
              role="alert"
            >
              <v-icon small color="#b54708">mdi-alert-outline</v-icon>
              <div>{{ plano.erro }}</div>
            </div>
            <div
              v-if="erroRetomada"
              class="roteirizacao-aviso roteirizacao-aviso--alerta"
            >
              <v-icon small color="#b54708">mdi-alert-outline</v-icon>
              <div class="roteirizacao-aviso__conteudo">
                {{ $t("roteirizacaoPedidos.planejamentoPreservado") }}
                <span class="roteirizacao-aviso__acoes">
                  <v-btn
                    small
                    text
                    class="text-none"
                    :disabled="requesting"
                    @click="abrir"
                  >
                    {{ $t("roteirizacaoPedidos.tentarRetomar") }}
                  </v-btn>
                  <v-btn
                    small
                    text
                    class="text-none"
                    :disabled="requesting"
                    @click="novoPlanejamento"
                  >
                    {{ $t("roteirizacaoPedidos.selecionarOutros") }}
                  </v-btn>
                </span>
              </div>
            </div>

            <template v-if="!plano && !erroRetomada">
              <section class="crud-listagem-card roteirizacao-secao">
                <div class="crud-listagem-section-heading">
                  <v-icon small color="#5e72e4">mdi-tune-variant</v-icon>
                  {{ $t("roteirizacaoPedidos.secaoPlanejamento") }}
                </div>
                <v-row dense align="center">
                  <v-col cols="12" sm="6" md="3">
                    <span class="roteirizacao-rotulo">
                      {{ $t("roteirizacaoPedidos.dataPedidos") }}
                    </span>
                    <v-text-field
                      v-model="data"
                      type="date"
                      hide-details
                      :disabled="requesting"
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                      "
                      dense
                      flat
                      filled
                      solo
                      @change="carregarPedidos"
                    />
                  </v-col>
                  <v-col v-if="planosSalvos.length" cols="12" sm="6" md="4">
                    <span class="roteirizacao-rotulo">
                      {{ $t("roteirizacaoPedidos.retomarSalvo") }}
                    </span>
                    <v-autocomplete
                      v-model="planoEscolhido"
                      :items="opcoesPlanosSalvos"
                      :placeholder="$t('roteirizacaoPedidos.retomarSalvoAjuda')"
                      :disabled="requesting"
                      clearable
                      hide-details
                      class="
                        input-style
                        font-size-input
                        text-light-input
                        placeholder-light
                      "
                      dense
                      flat
                      filled
                      solo
                      @change="retomarSalvo"
                    />
                  </v-col>
                  <v-col cols="12" :md="planosSalvos.length ? 5 : 9">
                    <span class="roteirizacao-rotulo">
                      {{ $t("roteirizacaoPedidos.temposAtendimento") }}
                    </span>
                    <div class="roteirizacao-tempos">
                      <span class="roteirizacao-tempos__item">
                        {{ $t("roteirizacaoPedidos.coleta") }}
                        <strong>
                          {{
                            $t("roteirizacaoPedidos.minutos", {
                              valor: duracoes.coleta,
                            })
                          }}
                        </strong>
                      </span>
                      <span class="roteirizacao-tempos__item">
                        {{ $t("roteirizacaoPedidos.entrega") }}
                        <strong>
                          {{
                            $t("roteirizacaoPedidos.minutos", {
                              valor: duracoes.entrega,
                            })
                          }}
                        </strong>
                      </span>
                      <span class="roteirizacao-tempos__item">
                        {{ $t("roteirizacaoPedidos.assistencia") }}
                        <strong>
                          {{
                            $t("roteirizacaoPedidos.minutos", {
                              valor: duracoes.assistencia,
                            })
                          }}
                        </strong>
                      </span>
                      <router-link
                        :to="{ name: 'RoteirizadorParametro' }"
                        target="_blank"
                        class="roteirizacao-link"
                      >
                        <v-icon x-small color="#5e72e4" class="mr-1">
                          mdi-cog-outline
                        </v-icon>
                        {{ $t("roteirizacaoPedidos.configurarTempos") }}
                      </router-link>
                    </div>
                  </v-col>
                </v-row>
                <p class="roteirizacao-orientacao">
                  <v-icon x-small color="#667085" class="mr-1">
                    mdi-information-outline
                  </v-icon>
                  {{ $t("roteirizacaoPedidos.orientacao") }}
                </p>
              </section>

              <div class="roteirizacao-indicadores">
                <div class="roteirizacao-indicador">
                  <span>{{ $t("roteirizacaoPedidos.disponiveis") }}</span>
                  <strong>{{ pedidosDisponiveis.length }}</strong>
                </div>
                <div
                  class="
                    roteirizacao-indicador roteirizacao-indicador--destaque
                  "
                >
                  <span>{{ $t("roteirizacaoPedidos.selecionados") }}</span>
                  <strong>{{ selecionados.length }}</strong>
                </div>
                <button
                  type="button"
                  class="roteirizacao-indicador"
                  :class="{
                    'roteirizacao-indicador--alerta': pedidosComLocalizacao,
                  }"
                  :disabled="!podeVerLocalizacoes"
                  @click="listaLocalizacoes = true"
                >
                  <span>{{ $t("roteirizacaoPedidos.aCorrigir") }}</span>
                  <strong>{{ pedidosComLocalizacao }}</strong>
                </button>
                <div class="roteirizacao-indicador">
                  <span>{{ $t("roteirizacaoPedidos.indisponiveis") }}</span>
                  <strong>{{
                    pedidos.length - pedidosDisponiveis.length
                  }}</strong>
                </div>
              </div>

              <section class="crud-listagem-card roteirizacao-secao pa-0">
                <div class="roteirizacao-secao__barra">
                  <div class="crud-listagem-section-heading mb-0">
                    <v-icon small color="#5e72e4">
                      mdi-package-variant-closed
                    </v-icon>
                    {{ $t("roteirizacaoPedidos.secaoPedidos") }}
                  </div>
                  <v-text-field
                    v-model="buscaPedidos"
                    :placeholder="$t('roteirizacaoPedidos.filtrarPedidos')"
                    clearable
                    hide-details
                    class="
                      roteirizacao-busca
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                  >
                    <template slot="prepend-inner">
                      <v-icon color="#adb5bd" size=".875rem">
                        fas fa-search
                      </v-icon>
                    </template>
                  </v-text-field>
                  <div class="roteirizacao-secao__acoes">
                    <v-btn
                      small
                      text
                      class="text-none"
                      :disabled="
                        requesting || !pedidosFiltrados.some((p) => p.elegivel)
                      "
                      @click="selecionarPedidosFiltrados"
                    >
                      <v-icon left small
                        >mdi-checkbox-multiple-marked-outline</v-icon
                      >
                      {{ $t("roteirizacaoPedidos.selecionarEncontrados") }}
                    </v-btn>
                    <v-btn
                      small
                      text
                      class="text-none"
                      :disabled="requesting || !selecionados.length"
                      @click="selecionados = []"
                    >
                      <v-icon left small>mdi-checkbox-blank-off-outline</v-icon>
                      {{ $t("roteirizacaoPedidos.limparSelecao") }}
                    </v-btn>
                    <v-btn
                      v-if="podeVerLocalizacoes"
                      small
                      text
                      class="text-none"
                      @click="listaLocalizacoes = true"
                    >
                      <v-icon left small>mdi-map-marker-radius</v-icon>
                      {{ $t("roteirizacaoPedidos.localizacoes") }}
                    </v-btn>
                  </div>
                </div>
                <div
                  v-if="pedidosSelecionadosForaFiltro"
                  class="roteirizacao-secao__nota"
                >
                  {{
                    $t("roteirizacaoPedidos.foraFiltro", {
                      quantidade: pedidosSelecionadosForaFiltro,
                    })
                  }}
                </div>
                <v-data-table
                  v-model="selecionados"
                  :headers="headersPedidos"
                  :items="pedidosFiltrados"
                  item-key="id"
                  show-select
                  :items-per-page="15"
                  :no-data-text="$t('roteirizacaoPedidos.semPedidos')"
                  :footer-props="{
                    'items-per-page-options': [15, 50, 100],
                  }"
                  class="crud-listagem-table roteirizacao-tabela"
                >
                  <template #header.data-table-select="{ props, on }"
                    ><input
                      type="checkbox"
                      class="routing-checkbox"
                      :checked="props.value"
                      :indeterminate.prop="props.indeterminate"
                      :disabled="requesting"
                      :aria-label="$t('roteirizacaoPedidos.selecionarPagina')"
                      @change="on.input($event.target.checked)"
                  /></template>
                  <template
                    #item.data-table-select="{ item, isSelected, select }"
                    ><input
                      type="checkbox"
                      class="routing-checkbox"
                      :checked="isSelected"
                      :disabled="requesting || !item.elegivel"
                      :aria-label="
                        $t('roteirizacaoPedidos.selecionarPedido', {
                          pedido: item.id,
                        })
                      "
                      @click.stop
                      @change="select($event.target.checked)"
                  /></template>
                  <template #item.id="{ item }">
                    <strong>{{ item.id }}</strong>
                  </template>
                  <template #item.valor="{ item }">{{
                    moeda(item.valor)
                  }}</template>
                  <template #item.motivo="{ item }">
                    <span
                      class="roteirizacao-situacao"
                      :class="
                        item.elegivel
                          ? 'roteirizacao-situacao--ok'
                          : 'roteirizacao-situacao--erro'
                      "
                    >
                      <v-icon
                        x-small
                        :color="item.elegivel ? '#027a48' : '#b42318'"
                        class="mr-1"
                      >
                        {{
                          item.elegivel
                            ? "mdi-check-circle"
                            : "mdi-alert-circle-outline"
                        }}
                      </v-icon>
                      {{
                        item.elegivel
                          ? $t("roteirizacaoPedidos.disponivel")
                          : item.motivo
                      }}
                    </span>
                    <v-btn
                      v-if="
                        !item.elegivel &&
                        item.enderecoAjusteId &&
                        podeVerLocalizacoes
                      "
                      x-small
                      text
                      class="text-none px-1 roteirizacao-link"
                      @click="ajustarLocalizacao(item.enderecoAjusteId)"
                    >
                      <v-icon left x-small>mdi-map-marker-radius</v-icon>
                      {{ $t("roteirizacaoPedidos.ajustarMapa") }}
                    </v-btn>
                  </template>
                </v-data-table>
              </section>

              <div class="roteirizacao-rodape">
                <div class="roteirizacao-rodape__texto">
                  <strong>
                    {{
                      $t("roteirizacaoPedidos.selecionadosRodape", {
                        selecionados: selecionados.length,
                        disponiveis: pedidosDisponiveis.length,
                      })
                    }}
                  </strong>
                  <span
                    v-if="
                      pedidosDisponiveis.length > 1000 ||
                      selecionados.length > 1000
                    "
                    class="roteirizacao-rodape__alerta"
                  >
                    {{ $t("roteirizacaoPedidos.limite") }}
                  </span>
                </div>
                <v-btn
                  height="39"
                  :disabled="
                    requesting ||
                    !selecionados.length ||
                    selecionados.length > 1000
                  "
                  class="
                    ma-1
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    px-6
                  "
                  @click="planejar"
                >
                  <v-icon left>mdi-routes</v-icon>
                  {{
                    $tc("roteirizacaoPedidos.planejar", selecionados.length, {
                      quantidade: selecionados.length,
                    })
                  }}
                </v-btn>
              </div>
            </template>

            <template v-if="plano && plano.resultado">
              <div class="roteirizacao-indicadores">
                <div class="roteirizacao-indicador">
                  <span>{{ $t("roteirizacaoPedidos.roteiros") }}</span>
                  <strong>{{ resumoResultado.roteiros }}</strong>
                </div>
                <div
                  class="
                    roteirizacao-indicador roteirizacao-indicador--destaque
                  "
                >
                  <span>{{ $t("roteirizacaoPedidos.pedidosAtendidos") }}</span>
                  <strong>{{ resumoResultado.pedidos }}</strong>
                </div>
                <div class="roteirizacao-indicador">
                  <span>{{ $t("roteirizacaoPedidos.quilometros") }}</span>
                  <strong>{{ resumoResultado.km }}</strong>
                </div>
                <div class="roteirizacao-indicador">
                  <span>{{ $t("roteirizacaoPedidos.horas") }}</span>
                  <strong>{{ resumoResultado.horas }}</strong>
                </div>
                <div
                  class="roteirizacao-indicador"
                  :class="{
                    'roteirizacao-indicador--alerta':
                      resumoResultado.naoAlocados,
                  }"
                >
                  <span>{{ $t("roteirizacaoPedidos.naoAlocados") }}</span>
                  <strong>{{ resumoResultado.naoAlocados }}</strong>
                </div>
              </div>

              <div
                v-if="plano.estado !== 'APROVADO'"
                class="roteirizacao-aviso roteirizacao-aviso--info"
              >
                <v-icon small color="#175cd3">mdi-information-outline</v-icon>
                <div>{{ $t("roteirizacaoPedidos.revise") }}</div>
              </div>

              <div
                class="roteirizacao-abas"
                role="tablist"
                :aria-label="$t('roteirizacaoPedidos.titulo')"
              >
                <button
                  v-for="(aba, indice) in abas"
                  :key="aba.icone"
                  type="button"
                  role="tab"
                  class="roteirizacao-abas__botao"
                  :class="{
                    'roteirizacao-abas__botao--ativa': abaResultado === indice,
                  }"
                  :aria-selected="String(abaResultado === indice)"
                  @click="abaResultado = indice"
                >
                  <v-icon small class="mr-1">{{ aba.icone }}</v-icon>
                  {{ aba.texto }}
                </button>
              </div>

              <DistribuicaoPedidos
                :key="plano.id"
                v-show="abaResultado === 0"
                :plano="plano"
                :busy="ocupado"
                :readonly="plano.estado === 'APROVADO'"
                @transferir="transferirLote"
                @pendentes="transferenciasPendentes = $event"
              />
              <Roteirizacao
                v-if="abaResultado === 1"
                :embedded="true"
                :resultado="plano.resultado"
              />

              <div
                v-if="plano.estado === 'PRONTO'"
                class="roteirizacao-rodape roteirizacao-rodape--aprovacao"
              >
                <div class="roteirizacao-rodape__texto">
                  <strong>{{ $t("roteirizacaoPedidos.aprovarTitulo") }}</strong>
                  <span>
                    {{
                      $tc(
                        "roteirizacaoPedidos.aprovarTexto",
                        plano.resultado.resumoRotas.length,
                        { quantidade: plano.resultado.resumoRotas.length }
                      )
                    }}
                  </span>
                  <span
                    v-if="transferenciasPendentes"
                    class="roteirizacao-rodape__alerta"
                  >
                    {{
                      $t("roteirizacaoPedidos.transferenciasPendentes", {
                        quantidade: transferenciasPendentes,
                      })
                    }}
                  </span>
                  <span v-if="!podeAprovar" class="roteirizacao-rodape__alerta">
                    {{ $t("roteirizacaoPedidos.semPermissaoAprovar") }}
                  </span>
                </div>
                <div class="roteirizacao-rodape__escala">
                  <v-switch
                    v-model="escalasAutomaticas"
                    :disabled="ocupado || !podeGerarEscalas"
                    :label="$t('roteirizacaoPedidos.escalasAutomaticas')"
                    color="#5e72e4"
                    inset
                    dense
                    hide-details
                    class="mt-0 pt-0"
                  />
                  <span>
                    {{
                      !podeGerarEscalas
                        ? $t("roteirizacaoPedidos.semPermissaoEscala")
                        : escalasAutomaticas
                        ? $t("roteirizacaoPedidos.escalasAutomaticasAjuda")
                        : $t("roteirizacaoPedidos.escalasManuais")
                    }}
                  </span>
                </div>
                <v-btn
                  height="39"
                  :loading="requesting"
                  :disabled="
                    ocupado ||
                    !podeAprovar ||
                    transferenciasPendentes > 0 ||
                    !plano.resultado.rotas.length
                  "
                  class="
                    ma-1
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    px-6
                  "
                  @click="aprovar"
                >
                  <v-icon left>mdi-check-decagram-outline</v-icon>
                  {{ $t("roteirizacaoPedidos.aprovar") }}
                </v-btn>
              </div>
            </template>

            <div
              v-if="plano && plano.estado === 'FALHOU'"
              class="roteirizacao-aviso roteirizacao-aviso--alerta"
            >
              <v-icon small color="#b54708">mdi-alert-outline</v-icon>
              <div>{{ $t("roteirizacaoPedidos.falhou") }}</div>
            </div>

            <section
              v-if="publicacao"
              class="crud-listagem-card roteirizacao-secao"
            >
              <div class="roteirizacao-aviso roteirizacao-aviso--sucesso">
                <v-icon small color="#027a48">mdi-check-circle-outline</v-icon>
                <div>
                  {{
                    $t("roteirizacaoPedidos.publicado", {
                      pedidos: publicacao.pedidosRoteirizados,
                      roteiros: publicacao.roteiros.length,
                    })
                  }}
                </div>
              </div>
              <v-expansion-panels flat class="roteirizacao-publicados">
                <v-expansion-panel
                  v-for="roteiro in publicacao.roteiros"
                  :key="roteiro.id"
                >
                  <v-expansion-panel-header>
                    {{
                      $t("roteirizacaoPedidos.roteiroPublicado", {
                        roteiro: roteiro.roteiro,
                        placa: roteiro.placa,
                        inicio: exibirDataHora(roteiro.dataInicio),
                        fim: exibirDataHora(roteiro.dataTermino),
                      })
                    }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <PainelEscalaRoteiro
                      v-if="podeGerarEscalas"
                      :roteiro="roteiro"
                    />
                    <p v-else class="mb-0">
                      {{ $t("roteirizacaoPedidos.escalaSemPermissao") }}
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </section>
          </div>
        </v-card>
      </v-container>
    </v-dialog>
    <AjusteLocalizacaoEndereco
      v-model="ajusteLocalizacao"
      :endereco-id="enderecoAjuste"
      @salvo="carregarPedidos"
    />
    <LocalizacoesEnderecos
      v-model="listaLocalizacoes"
      @alterado="localizacaoAlterada = true"
      @input="!$event && localizacaoAlterada && recarregarAposLocalizacoes()"
    />
  </span>
</template>

<script>
import DataService from "@/services/ComumDataService";
import DistribuicaoPedidos from "@/components/operacoes/roteiros/DistribuicaoPedidos";
import Roteirizacao from "@/components/operacoes/roteiros/Roteirizacao";
import PainelEscalaRoteiro from "@/components/operacoes/roteiros/PainelEscalaRoteiro";
import AjusteLocalizacaoEndereco from "@/components/operacoes/roteiros/AjusteLocalizacaoEndereco";
import LocalizacoesEnderecos from "@/components/operacoes/roteiros/LocalizacoesEnderecos";

const url = "/roteirizador/pedidos";
export default {
  name: "RoteirizarPedidos",
  components: {
    DistribuicaoPedidos,
    Roteirizacao,
    PainelEscalaRoteiro,
    AjusteLocalizacaoEndereco,
    LocalizacoesEnderecos,
  },
  props: {
    obterData: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      ajusteLocalizacao: false,
      enderecoAjuste: null,
      listaLocalizacoes: false,
      localizacaoAlterada: false,
      data: "",
      pedidos: [],
      buscaPedidos: "",
      selecionados: [],
      duracoes: { coleta: 20, entrega: 20, assistencia: 20 },
      plano: null,
      publicacao: null,
      requesting: false,
      erro: "",
      erroRetomada: false,
      planosSalvos: [],
      planoEscolhido: null,
      escalasAutomaticas: false,
      abaResultado: 0,
      transferenciasPendentes: 0,
      selectRevision: 0,
      destroyed: false,
      pollToken: 0,
      loadToken: 0,
      requestKey: null,
      requestPayload: null,
      // Mensagem de conexão instável exibida, limpa quando o acompanhamento volta.
      erroConexao: "",
      headersDistribuicao: [
        { text: "Pedido", value: "pedido" },
        {
          text: "Coleta ou assistência / previsão",
          value: "origem",
          sortable: false,
        },
        {
          text: "Entrega ou conclusão / previsão",
          value: "destino",
          sortable: false,
        },
        {
          text: "Transferir o pedido completo",
          value: "placaVeiculo",
          sortable: false,
          width: "320px",
        },
      ],
    };
  },
  computed: {
    headersPedidos() {
      return [
        { text: this.$t("roteirizacaoPedidos.colunaPedido"), value: "id" },
        {
          text: this.$t("roteirizacaoPedidos.colunaCliente"),
          value: "cliente",
        },
        { text: this.$t("roteirizacaoPedidos.colunaOrigem"), value: "origem" },
        {
          text: this.$t("roteirizacaoPedidos.colunaDestino"),
          value: "destino",
        },
        {
          text: this.$t("roteirizacaoPedidos.colunaValor"),
          value: "valor",
          align: "end",
        },
        {
          text: this.$t("roteirizacaoPedidos.colunaSituacao"),
          value: "motivo",
        },
      ];
    },
    pedidosDisponiveis() {
      return this.pedidos.filter((p) => p.elegivel);
    },
    pedidosFiltrados() {
      const normalize = (value) =>
        String(value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
      const query = normalize(this.buscaPedidos).trim();
      return this.pedidos.filter(
        (p) =>
          !query ||
          normalize(
            [p.id, p.cliente, p.origem, p.destino, p.motivo].join(" ")
          ).includes(query)
      );
    },
    pedidosSelecionadosForaFiltro() {
      const visible = new Set(this.pedidosFiltrados.map((p) => p.id));
      return this.selecionados.filter((p) => !visible.has(p.id)).length;
    },
    opcoesPlanosSalvos() {
      return this.planosSalvos.map((p) => ({
        value: p.id,
        text: [
          this.exibirData(p.data),
          this.rotuloEstado(p.estado),
          p.pedidos != null
            ? this.$t("roteirizacaoPedidos.quantidadePedidos", {
                quantidade: p.pedidos,
              })
            : "",
        ]
          .filter(Boolean)
          .join(" · "),
      }));
    },
    dataFormatada() {
      return this.exibirData(this.data);
    },
    tenantId() {
      return this.$store.state.inquilino?.id;
    },
    storageKey() {
      return `roteirizacao-pedidos:${this.tenantId}`;
    },
    permissoes() {
      return this.$store.state.permissoes || [];
    },
    podeVerLocalizacoes() {
      return this.permissoes.includes("ROLE_Cliente_List");
    },
    pedidosComLocalizacao() {
      return this.pedidos.filter((p) => !p.elegivel && p.enderecoAjusteId)
        .length;
    },
    podePlanejar() {
      return ["Roteirizador_PlanejamentoRotas", "Pedido_List"].every((p) =>
        this.permissoes.includes(`ROLE_${p}`)
      );
    },
    podeAprovar() {
      return ["Pedido_Update", "Roteiro_Insert", "RoteiroTrajeto_Insert"].every(
        (p) => this.permissoes.includes(`ROLE_${p}`)
      );
    },
    podeGerarEscalas() {
      return this.permissoes.includes("ROLE_Roteiro_Update");
    },
    ocupado() {
      return (
        this.requesting ||
        ["PLANEJANDO", "RECALCULANDO"].includes(this.plano?.estado)
      );
    },
    progresso() {
      const fase = this.plano?.fase;
      return fase && this.$te(`roteirizacaoPedidos.fases.${fase}`)
        ? this.$t(`roteirizacaoPedidos.fases.${fase}`)
        : this.$t("roteirizacaoPedidos.processando");
    },
    processandoNoMotor() {
      return ["PLANEJANDO", "RECALCULANDO"].includes(this.plano?.estado);
    },
    // Overlay padrão do projeto enquanto busca dados ou o motor calcula.
    carregando() {
      return this.requesting || this.processandoNoMotor;
    },
    textoCarregamento() {
      return this.processandoNoMotor ? this.progresso : this.$t("Carregando");
    },
    etapas() {
      return [
        this.$t("roteirizacaoPedidos.etapaSelecionar"),
        this.$t("roteirizacaoPedidos.etapaRevisar"),
        this.$t("roteirizacaoPedidos.etapaAprovar"),
      ];
    },
    etapaAtual() {
      if (!this.plano) return 0;
      return this.plano.estado === "APROVADO" ? 3 : 1;
    },
    abas() {
      return [
        {
          icone: "mdi-swap-horizontal",
          texto: this.$t("roteirizacaoPedidos.abaDistribuir"),
        },
        {
          icone: "mdi-map-outline",
          texto: this.$t("roteirizacaoPedidos.abaMapa"),
        },
      ];
    },
    resumoResultado() {
      const resultado = this.plano?.resultado || {};
      const rotas = resultado.resumoRotas || [];
      const km = rotas.reduce((soma, rota) => soma + (rota.totalKm || 0), 0);
      const horas = rotas.reduce(
        (soma, rota) => soma + (rota.totalHorasTotal || rota.totalHoras || 0),
        0
      );
      const minutos = Math.round(horas * 60);
      return {
        roteiros: rotas.length,
        pedidos: resultado.pedidosAtendidos ?? (resultado.rotas || []).length,
        km: km.toLocaleString("pt-BR", { maximumFractionDigits: 1 }),
        horas: `${Math.floor(minutos / 60)}h${String(minutos % 60).padStart(
          2,
          "0"
        )}`,
        naoAlocados: (resultado.atendimentosInviaveis || []).length,
      };
    },
    opcoesVeiculos() {
      return (this.plano?.veiculos || []).map((v) => {
        const rota = this.plano.resultado?.resumoRotas.find(
          (r) => r.placaVeiculo === v.placa
        );
        return {
          value: v.placa,
          text: `${rota ? `Roteiro ${rota.numeroRota}` : "Novo roteiro"} · ${
            v.placa
          }`,
        };
      });
    },
  },
  watch: {
    tenantId() {
      this.dialog = false;
      this.pollToken++;
      this.loadToken++;
      this.requesting = false;
      this.plano = null;
      this.publicacao = null;
      this.planosSalvos = [];
    },
  },
  activated() {
    this.destroyed = false;
  },
  deactivated() {
    this.requesting = false;
    this.dialog = false;
    this.pollToken++;
    this.loadToken++;
  },
  beforeDestroy() {
    this.destroyed = true;
    this.dialog = false;
    this.pollToken++;
    this.loadToken++;
  },
  methods: {
    exibirData(value) {
      return value ? value.split("-").reverse().join("/") : "";
    },
    selecionarPedidosFiltrados() {
      if (this.requesting) return;
      this.selecionados = this.pedidosFiltrados.filter((p) => p.elegivel);
    },
    lerPlanosSalvos() {
      try {
        const stored = JSON.parse(
          localStorage.getItem(this.storageKey + ":historico") || "[]"
        );
        const legacy = JSON.parse(
          localStorage.getItem(this.storageKey + ":anterior") || "null"
        );
        const merged = [
          ...(legacy ? [legacy] : []),
          ...(Array.isArray(stored) ? stored : []),
        ];
        return [
          ...new Map(
            merged
              .filter(
                (p) =>
                  p && typeof p.id === "string" && typeof p.data === "string"
              )
              .map((p) => [p.id, p])
          ).values(),
        ];
      } catch (error) {
        return this.planosSalvos || [];
      }
    },
    registrarPlano(data) {
      const history = new Map(
        [...(this.planosSalvos || []), ...this.lerPlanosSalvos()].map((p) => [
          p.id,
          p,
        ])
      );
      const prior = history.get(data.id);
      const entry = {
        id: data.id,
        data: data.data,
        estado: data.estado,
        revisao: data.revisao,
        pedidos: data.resultado?.pedidosAtendidos ?? prior?.pedidos,
      };
      if (prior?.estado === "APROVADO") entry.estado = "APROVADO";
      history.delete(data.id);
      const all = [entry, ...history.values()];
      let approved = 0;
      this.planosSalvos = all.filter(
        (p) => p.estado !== "APROVADO" || ++approved <= 5
      );
      try {
        localStorage.setItem(
          this.storageKey + ":historico",
          JSON.stringify(this.planosSalvos)
        );
        return true;
      } catch (error) {
        this.erro = this.$t("roteirizacaoPedidos.erroGuardarRetomada");
        return false;
      }
    },
    async retomarSalvo(id) {
      if (!id || this.requesting) return;
      this.planoEscolhido = null;
      await this.abrir(id);
    },
    async atualizarPlano() {
      const tenant = this.tenantId;
      this.requesting = true;
      this.erro = "";
      try {
        const { data } = await DataService.get(
          `${url}/planejamentos/${this.plano.id}`
        );
        if (tenant !== this.tenantId || this.destroyed) return;
        this.receber(data);
      } catch (error) {
        if (tenant === this.tenantId) this.erro = this.mensagem(error);
      } finally {
        if (tenant === this.tenantId) this.requesting = false;
      }
      this.acompanhar();
    },
    async abrir(planoId) {
      this.dialog = true;
      this.erro = "";
      this.erroRetomada = false;
      this.planosSalvos = this.lerPlanosSalvos();
      this.planoEscolhido = null;
      this.data = this.obterData() || new Date().toLocaleDateString("sv-SE");
      const selectedDate = this.data;
      const tenant = this.tenantId;
      const explicit = typeof planoId === "string";
      const saved = explicit ? planoId : localStorage.getItem(this.storageKey);
      this.plano = null;
      this.publicacao = null;
      if (saved) {
        this.requesting = true;
        try {
          const { data } = await DataService.get(
            `${url}/planejamentos/${saved}`
          );
          if (tenant !== this.tenantId || this.destroyed) return;
          if (
            !explicit &&
            (data.data !== selectedDate || data.estado === "APROVADO")
          ) {
            this.registrarPlano(data);
            if (
              data.estado === "APROVADO" &&
              localStorage.getItem(this.storageKey) === saved
            )
              localStorage.removeItem(this.storageKey);
          } else this.receber(data);
        } catch (error) {
          if (tenant !== this.tenantId || this.destroyed) return;
          if (error.response?.status === 404) {
            if (localStorage.getItem(this.storageKey) === saved)
              localStorage.removeItem(this.storageKey);
            localStorage.removeItem(`roteirizacao-transferencias:${saved}`);
            this.planosSalvos = this.planosSalvos.filter((p) => p.id !== saved);
            localStorage.setItem(
              this.storageKey + ":historico",
              JSON.stringify(this.planosSalvos)
            );
            const legacy = JSON.parse(
              localStorage.getItem(this.storageKey + ":anterior") || "null"
            );
            if (legacy?.id === saved)
              localStorage.removeItem(this.storageKey + ":anterior");
          } else {
            this.erro = this.mensagem(error);
            this.erroRetomada = true;
          }
        } finally {
          if (tenant === this.tenantId) this.requesting = false;
        }
        if (
          this.plano &&
          ["PLANEJANDO", "RECALCULANDO"].includes(this.plano.estado)
        )
          this.acompanhar();
      }
      if (!this.plano && !this.erroRetomada) await this.carregarPedidos();
    },
    fechar() {
      if (this.requesting) return;
      this.dialog = false;
      this.pollToken++;
      this.loadToken++;
    },
    async novoPlanejamento() {
      if (this.plano && !this.registrarPlano(this.plano)) return;
      this.erroRetomada = false;
      this.pollToken++;
      this.plano = null;
      this.publicacao = null;
      this.erro = "";
      this.requestKey = null;
      localStorage.removeItem(this.storageKey);
      this.data = this.obterData() || this.data;
      await this.carregarPedidos();
    },
    ajustarLocalizacao(enderecoId) {
      this.enderecoAjuste = enderecoId;
      this.ajusteLocalizacao = true;
    },
    recarregarAposLocalizacoes() {
      this.localizacaoAlterada = false;
      if (!this.plano) this.carregarPedidos();
    },
    async carregarPedidos() {
      const token = ++this.loadToken;
      this.requesting = true;
      this.erro = "";
      this.pedidos = [];
      this.selecionados = [];
      this.requestKey = null;
      try {
        const [response, configuration] = await Promise.all([
          DataService.get(url, { params: { data: this.data } }),
          DataService.get(`${url}/configuracao`, {
            params: { data: this.data },
          }),
        ]);
        const data = response.data;
        if (token !== this.loadToken) return;
        this.duracoes = configuration.data;
        this.pedidos = data.map((p) => ({
          ...p,
          indisponivel: !p.elegivel,
          isSelectable: p.elegivel,
        }));
        const eligible = this.pedidos.filter((p) => p.elegivel);
        this.selecionados = eligible.length <= 1000 ? eligible : [];
      } catch (error) {
        if (token === this.loadToken) this.erro = this.mensagem(error);
      } finally {
        if (token === this.loadToken) this.requesting = false;
      }
    },
    receber(data) {
      if (this.destroyed) return;
      this.selectRevision++;
      const previous = this.plano;
      this.plano = {
        ...data,
        resultado:
          data.resultado ||
          (previous?.id === data.id && previous?.revisao === data.revisao
            ? previous.resultado
            : undefined),
      };
      this.data = data.data;
      this.publicacao = data.publicacao || null;
      this.registrarPlano(this.plano);
      const archived = this.planosSalvos.find((p) => p.id === data.id);
      if (archived?.estado === "APROVADO") {
        if (localStorage.getItem(this.storageKey) === data.id)
          localStorage.removeItem(this.storageKey);
      } else localStorage.setItem(this.storageKey, data.id);
    },
    async acompanhar() {
      const token = ++this.pollToken;
      let falhas = 0;
      while (
        !this.destroyed &&
        this.dialog &&
        token === this.pollToken &&
        ["PLANEJANDO", "RECALCULANDO"].includes(this.plano?.estado)
      ) {
        await new Promise((resolve) =>
          setTimeout(resolve, Math.min(8000, 1500 * 2 ** falhas))
        );
        if (!this.dialog || token !== this.pollToken) return;
        try {
          const { data } = await DataService.get(
            `${url}/planejamentos/${this.plano.id}`,
            { params: { revisaoConhecida: this.plano.revisao }, timeout: 15000 }
          );
          if (token !== this.pollToken) return;
          this.receber(data);
          falhas = 0;
          if (this.erroConexao && this.erro === this.erroConexao)
            this.erro = "";
          this.erroConexao = "";
        } catch (error) {
          if (!this.dialog || token !== this.pollToken) return;
          falhas++;
          if (
            falhas >= 3 ||
            [400, 401, 403, 404].includes(error.response?.status)
          ) {
            this.erro = this.mensagem(error);
            this.erroConexao = "";
            return;
          }
          this.erroConexao = this.$t("roteirizacaoPedidos.conexaoInstavel", {
            tentativa: falhas,
          });
          this.erro = this.erroConexao;
        }
      }
    },
    async planejar() {
      if (this.ocupado) return;
      const tenant = this.tenantId;
      this.requesting = true;
      this.erro = "";
      const payload = {
        data: this.data,
        pedidos: this.selecionados
          .filter((p) => p.elegivel)
          .map((p) => p.id)
          .sort((a, b) => a - b),
      };
      const signature = JSON.stringify(payload);
      if (signature !== this.requestPayload) this.requestKey = null;
      this.requestPayload = signature;
      this.requestKey = this.requestKey || crypto.randomUUID();
      try {
        const { data } = await DataService.post(`${url}/planejamentos`, {
          data: this.data,
          pedidos: this.selecionados.filter((p) => p.elegivel).map((p) => p.id),
          requisicaoId: this.requestKey,
        });
        if (tenant !== this.tenantId || this.destroyed) return;
        this.receber(data);
      } catch (error) {
        if (tenant === this.tenantId) this.erro = this.mensagem(error);
      } finally {
        if (tenant === this.tenantId) this.requesting = false;
      }
      if (this.plano) this.acompanhar();
    },
    async transferir(pedido, placaDestino) {
      return this.transferirLote([{ pedido, placaDestino }]);
    },
    async transferirLote(transferencias) {
      if (this.ocupado || this.plano.estado !== "PRONTO") return;
      const tenant = this.tenantId;
      this.requesting = true;
      this.erro = "";
      try {
        const { data } = await DataService.post(
          `${url}/planejamentos/${this.plano.id}/transferencias`,
          {
            revisao: this.plano.revisao,
            transferencias,
          }
        );
        if (tenant !== this.tenantId || this.destroyed) return;
        this.receber(data);
      } catch (error) {
        if (tenant === this.tenantId) this.erro = this.mensagem(error);
        this.selectRevision++;
      } finally {
        if (tenant === this.tenantId) this.requesting = false;
      }
      this.acompanhar();
    },
    async aprovar() {
      if (
        this.ocupado ||
        this.transferenciasPendentes ||
        this.plano.estado !== "PRONTO"
      )
        return;
      const tenant = this.tenantId;
      this.requesting = true;
      this.erro = "";
      try {
        const { data } = await DataService.post(
          `${url}/planejamentos/${this.plano.id}/aprovacao`,
          {
            revisao: this.plano.revisao,
            gerarEscalasAutomaticamente: this.escalasAutomaticas,
          }
        );
        if (tenant !== this.tenantId || this.destroyed) return;
        this.publicacao = data;
        this.plano = { ...this.plano, estado: "APROVADO", publicacao: data };
        this.registrarPlano(this.plano);
        if (localStorage.getItem(this.storageKey) === this.plano.id)
          localStorage.removeItem(this.storageKey);
        this.$emit("gerado", data);
      } catch (error) {
        if (tenant === this.tenantId) this.erro = this.mensagem(error);
      } finally {
        if (tenant === this.tenantId) this.requesting = false;
      }
    },
    mensagem(error) {
      return (
        error.response?.data?.errors?.map((item) => item.message).join(" ") ||
        error.response?.data?.message ||
        error.response?.data?.msg ||
        error.message ||
        this.$t("roteirizacaoPedidos.erroOperacao")
      );
    },
    rotuloEstado(estado) {
      return this.$te(`roteirizacaoPedidos.estados.${estado}`)
        ? this.$t(`roteirizacaoPedidos.estados.${estado}`)
        : this.$t("roteirizacaoPedidos.estados.RASCUNHO");
    },
    horario(pedido, tipo) {
      const parada = this.plano.resultado.paradas.find(
        (p) =>
          p.pedido === pedido &&
          (p.tipo === tipo ||
            (tipo === "COLETA" && p.tipo === "ASSISTENCIA") ||
            (tipo === "ENTREGA" && p.tipo === "CONCLUSAO_ASSISTENCIA"))
      );
      return this.exibirDataHora(parada?.inicioAtendimento);
    },
    exibirDataHora(value) {
      if (!value) return "";
      const [date, time] = value.split("T");
      return `${date.split("-").reverse().join("/")} ${time.substring(0, 5)}`;
    },
    moeda(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>

<style scoped>
/* O cartão do CRUD corta o conteúdo; aqui o topo e o rodapé ficam fixos na rolagem. */
.roteirizacao__cartao {
  overflow: visible !important;
}

.roteirizacao__topbar {
  border-radius: 12px 12px 0 0;
  position: sticky;
  top: 0;
  z-index: 12;
}

.roteirizacao__cabecalho {
  flex-wrap: wrap;
  gap: 16px;
}

.roteirizacao__subtitulo {
  align-items: center;
  color: #667085;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.8rem;
  font-weight: 600;
  gap: 4px;
  margin-top: 4px;
}

.roteirizacao__estado {
  background: #eef1ff;
  border-radius: 999px;
  color: #3e4fb8;
  font-size: 0.7rem;
  font-weight: 800;
  margin-left: 6px;
  padding: 2px 9px;
}

.roteirizacao-etapas {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.roteirizacao-etapas__item {
  align-items: center;
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 999px;
  color: #667085;
  display: flex;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 8px;
  padding: 5px 12px 5px 5px;
}

.roteirizacao-etapas__numero {
  align-items: center;
  background: #f2f4f7;
  border-radius: 50%;
  color: #667085;
  display: inline-flex;
  font-size: 0.7rem;
  font-weight: 800;
  height: 22px;
  justify-content: center;
  width: 22px;
}

.roteirizacao-etapas__item--ativa {
  background: #f5f7ff;
  border-color: #cdd5f8;
  color: #344054;
}

.roteirizacao-etapas__item--ativa .roteirizacao-etapas__numero {
  background: #5e72e4;
  color: #fff;
}

.roteirizacao-etapas__item--concluida .roteirizacao-etapas__numero {
  background: #2dce89;
}

.roteirizacao__corpo {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 360px;
  padding: 18px 22px 22px;
}

.roteirizacao__carregando {
  align-items: flex-start;
  border-radius: 0 0 12px 12px;
  z-index: 11;
}

.roteirizacao__carregando .loading-card {
  margin-top: 12vh;
  position: sticky;
  top: calc(64px + 18vh);
}

.roteirizacao__carregando-ajuda {
  color: #667085;
  font-size: 0.75rem;
  font-weight: 600;
}

.roteirizacao-aviso {
  align-items: flex-start;
  border: 1px solid;
  border-radius: 10px;
  display: flex;
  font-size: 0.82rem;
  gap: 10px;
  line-height: 1.45;
  padding: 10px 14px;
}

.roteirizacao-aviso .v-icon {
  margin-top: 2px;
}

.roteirizacao-aviso--info {
  background: #eff4ff;
  border-color: #d1e0ff;
  color: #1d3f8f;
}

.roteirizacao-aviso--alerta {
  background: #fffaeb;
  border-color: #fedf89;
  color: #7a2e0e;
}

.roteirizacao-aviso--erro {
  background: #fef3f2;
  border-color: #fecdca;
  color: #912018;
}

.roteirizacao-aviso--sucesso {
  background: #ecfdf3;
  border-color: #abefc6;
  color: #05603a;
}

.roteirizacao-aviso__acoes {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: 4px;
}

.roteirizacao-secao {
  background: #fff;
  padding: 16px 18px;
}

.roteirizacao-rotulo {
  color: #667085;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.roteirizacao-tempos {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
}

.roteirizacao-tempos__item {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  color: #475467;
  display: inline-flex;
  font-size: 0.78rem;
  gap: 6px;
  padding: 6px 10px;
}

.roteirizacao-tempos__item strong {
  color: #202538;
}

.roteirizacao-link {
  color: #5e72e4 !important;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
}

.roteirizacao-orientacao {
  color: #667085;
  font-size: 0.76rem;
  line-height: 1.45;
  margin: 12px 0 0;
}

.roteirizacao-indicadores {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}

.roteirizacao-indicador {
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(33, 43, 54, 0.04);
  display: flex;
  flex-direction: column;
  font: inherit;
  gap: 2px;
  padding: 12px 14px;
  text-align: left;
}

.roteirizacao-indicador span {
  color: #667085;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.roteirizacao-indicador strong {
  color: #202538;
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.2;
}

button.roteirizacao-indicador:not(:disabled) {
  cursor: pointer;
}

button.roteirizacao-indicador:not(:disabled):hover {
  border-color: #cdd5f8;
}

button.roteirizacao-indicador:focus-visible {
  outline: 3px solid #8da8ff;
  outline-offset: 2px;
}

.roteirizacao-indicador--destaque {
  background: #f5f7ff;
  border-color: #cdd5f8;
}

.roteirizacao-indicador--destaque strong {
  color: #3e4fb8;
}

.roteirizacao-indicador--alerta {
  background: #fffaeb;
  border-color: #fedf89;
}

.roteirizacao-indicador--alerta strong {
  color: #b54708;
}

.roteirizacao-secao__barra {
  align-items: center;
  border-bottom: 1px solid #edf0f4;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 18px;
}

.roteirizacao-busca {
  flex: 1 1 260px;
  max-width: 420px;
}

.roteirizacao-secao__acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-left: auto;
}

.roteirizacao-secao__nota {
  background: #fffaeb;
  border-bottom: 1px solid #fde7b0;
  color: #8a4b00;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 8px 18px;
}

.roteirizacao-tabela ::v-deep thead th {
  vertical-align: middle;
  white-space: nowrap;
}

.roteirizacao-situacao {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.35;
  padding: 3px 9px;
}

.roteirizacao-situacao--ok {
  background: #ecfdf3;
  color: #027a48;
}

.roteirizacao-situacao--erro {
  background: #fef3f2;
  color: #b42318;
}

.roteirizacao-abas {
  align-self: flex-start;
  border: 1px solid #d8e3f8;
  border-radius: 9px;
  display: inline-flex;
  flex-wrap: wrap;
  overflow: hidden;
}

.roteirizacao-abas__botao {
  align-items: center;
  background: #fff;
  border: 0;
  color: #52627a;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 700;
  justify-content: center;
  min-width: 170px;
  padding: 9px 16px;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.roteirizacao-abas__botao + .roteirizacao-abas__botao {
  border-left: 1px solid #d8e3f8;
}

.roteirizacao-abas__botao .v-icon {
  color: inherit;
}

.roteirizacao-abas__botao--ativa {
  background: linear-gradient(135deg, #1d7af8 0%, #145cc7 100%);
  color: #fff;
}

.roteirizacao-abas__botao:focus-visible {
  outline: 3px solid #8da8ff;
  outline-offset: -3px;
}

.roteirizacao-rodape {
  align-items: center;
  background: #fbfcfe;
  border-radius: 0 0 12px 12px;
  border-top: 1px solid #edf0f4;
  bottom: 0;
  box-shadow: 0 -8px 20px rgba(33, 43, 54, 0.06);
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  justify-content: space-between;
  margin: 0 -22px -22px;
  padding: 12px 22px;
  position: sticky;
  z-index: 9;
}

.roteirizacao-rodape__texto {
  color: #475467;
  display: flex;
  flex: 1 1 320px;
  flex-direction: column;
  font-size: 0.8rem;
  gap: 2px;
  min-width: 0;
}

.roteirizacao-rodape__texto strong {
  color: #202538;
  font-size: 0.88rem;
}

.roteirizacao-rodape__alerta {
  color: #b54708;
  font-weight: 700;
}

.roteirizacao-rodape__escala {
  color: #667085;
  display: flex;
  flex-direction: column;
  font-size: 0.74rem;
  gap: 2px;
  line-height: 1.35;
  max-width: 380px;
}

.roteirizacao-rodape__escala ::v-deep .v-label {
  color: #344054;
  font-size: 0.82rem;
  font-weight: 700;
}

.roteirizacao-publicados {
  border: 1px solid #e6e9ef;
  border-radius: 10px;
  margin-top: 12px;
  overflow: hidden;
}

.routing-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #5e72e4;
  cursor: pointer;
  vertical-align: middle;
}

.routing-checkbox:focus-visible {
  outline: 3px solid #8da8ff;
  outline-offset: 2px;
}

@media (max-width: 959px) {
  .roteirizacao__corpo {
    padding: 14px 16px 16px;
  }

  .roteirizacao-rodape {
    margin: 0 -16px -16px;
    padding: 12px 16px;
  }

  .roteirizacao-secao__acoes {
    margin-left: 0;
  }

  .roteirizacao-busca {
    max-width: none;
  }
}
</style>
